import { render } from "./DeviatingMissingDistance.vue?vue&type=template&id=56af9900"
import script from "./DeviatingMissingDistance.vue?vue&type=script&lang=ts"
export * from "./DeviatingMissingDistance.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QPage from 'quasar/src/components/page/QPage.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage});
